import { ValidationRepository } from "../../repositories/ValidationRepository";
import { ValidationResponse } from "../../entities/ValidationEntity";
import { BillEntity } from "../../entities/BillEntity";

export class ValidateBillUseCase {
  constructor(private validationRepository: ValidationRepository) {}

  async execute(
    billData: any,
    billDocument: BillEntity,
    validationType: string = "full_validation"
  ): Promise<ValidationResponse> {
    return await this.validationRepository.validateBill(billData, billDocument, validationType);
  }
}

